<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <px-cancelar-dialog
        texto-botao="Cancelar cotação"
        :titulo="getTitulo"
        :descricao="getDescricao"
        @cancelar-dialog="onClickCancelar"
        :disabled="!isAberta"
        v-if="!isRascunho"/>
      <v-list-item v-if="!isRascunho" :disabled="!isAberta" @click="goToEditCotacao(cotacao)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Editar cotação</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho"
                  @click="goToEditCotacaoRascunho(cotacao)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Editar rascunho
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!isRascunho" @click="goToCopy">
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Copiar cotação</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho" @click="onClickRemove(cotacao)">
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Remover rascunho
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import CotacaoService from '@/modules/cotacao/cotacao-service';

export default {
  props: {
    cotacao: Object,
  },
  computed: {
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao
      || SituacaoCotacao.keys.EM_ANDAMENTO.key === this.cotacao.situacao;
    },
    isRascunho() {
      return SituacaoCotacao.keys.RASCUNHO.key === this.cotacao.situacao;
    },
    getTitulo() {
      return 'Cancelar cotação';
    },
    getDescricao() {
      return `A cotação "${this.cotacao.identificador}" será cancelada e não poderá mais receber respostas.<br/>Esta operação não pode ser desfeita.`;
    },
  },
  methods: {
    goToCopy() {
      this.$router.push({
        name: 'main.cotacoes.cadastro',
        params: {
          id: this.cotacao.id,
          isRascunho: false,
          isCopy: true,
        },
      });
    },
    goToEditCotacao(cotacao) {
      this.$router.push({
        name: 'main.cotacoes.edicao-parcial',
        params: {
          id: cotacao.id,
        },
      });
    },
    goToEditCotacaoRascunho(cotacao) {
      this.$router.push({
        name: 'main.cotacoes.edicao',
        params: {
          id: cotacao.id,
          isRascunho: true,
          isCopy: false,
        },
      });
    },
    remove(cotacao) {
      this.$emit('remove', cotacao);
    },
    onClickRemove(cotacao) {
      this.$refs.confirm.open('Você deseja remover este rascunho?',
        'A cotação será removida e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(cotacao);
        });
    },
    emitUpdate() {
      this.$emit('update');
    },
    onClickCancelar(motivoRecusa) {
      CotacaoService.cancelar(this.cotacao.id, { motivoRecusa })
        .then(() => {
          this.emitUpdate();
          this.$toast('Cotação cancelada com sucesso', { color: 'success' });
        });
    },
  },
};
</script>
